<template>
<gkFormText
  class="captcha-text"
  :class="{'text-tips': tipsLabel}"
  validity
  :group="group"
  :field="field"
  :trigger="trigger"
  type="text"
  :size="size"
  :color="color"
  :placeholder="placeholder"
  :length="length"
  :rule="mergeRule"
  :readonly="readonly"
  :customRule="customRule"
  :tips="tipsLabel"
  v-model="currentValue"
  @input="$emit('input', $event)"
  @blur="$emit('blur', $event)"
  @focus="$emit('focus', $event)"
>
  <gkButton slot="end" use-lock :disabled="disabledBtn" @click="hadnleSend">
    {{sending ? time + ' 秒后重新获取' : sended ? '重新获取' : '获取验证码'}}
  </gkButton>
</gkFormText>
</template>

<script>
import VueTypes from 'vue-types'
// import {$nvcEvent, resetNC} from '@/utils/nvc'
// import utils from '../../utils'

import gkFormText from 'gkui/form/FormText'
import gkButton from 'gkui/button/Button'
import formProps from 'gkui/form/form.props'
import validityProps from 'gkui/form/validity.props'

export default {
  name: 'captcha',
  components: {
    gkFormText,
    gkButton
  },
  props: Object.assign({}, formProps, validityProps, {
    field: VueTypes.string.def('code'),
    placeholder: VueTypes.string.def('短信验证码'),
    length: VueTypes.number.def(6),
    rule: VueTypes.oneOfType([String, Array]).def([])
    // ,
    // helpData: VueTypes.string.def('')
    // ,
    // handleSend: Function
  }),
  data () {
    return {
      currentValue: this.value,
      sended: false,
      sending: false,
      tipsLabel: '',
      time: 60,
      loop: null
    }
  },
  computed: {
    mergeRule () {
      let rule = ['required']

      if (Array.isArray(this.rule)) {
        rule = rule.concat(this.rule)
      } else {
        rule.push(this.rule)
      }

      return rule.map(item => {
        if (item === 'required') {
          return {
            required: '请输入验证码'
          }
        }

        return item
      })
    },
    disabledBtn () {
      return this.disabled || this.sending
    }
  },
  watch: {
    helpData () {
      // this.showHelp = false
    },
    value (val) {
      this.currentValue = val
    }
  },
  mounted () {
    // $nvcEvent.on('sendSms', (nvcData) => {
    //   this.handleSend({}, nvcData)
    // })
  },
  methods: {
    /**
     * 显示提示
     */
    showTips () {
      this.tipsLabel = this.tips

      setTimeout(() => {
        this.tipsLabel = ''
      }, 3000)
    },
    /**
     * 点击发送验证码按钮
     */
    hadnleSend ({clear}) {
      const defer = new Promise((resolve, reject) => {
        this.$emit('send', {
          resolve: data => {
            resolve(data)
          },
          reject: err => {
            reject(err)
          }
          // data
        })
      })

      defer.then(res => {
        // resetNC()

        this.sending = true
        this.sended = true

        this.showTips()

        this.loopTime(clear)
      }).catch((err) => {
        this.sending = false

        if (err && err.cellphone === '') {
          this.sended = false
        }

        clear && clear()
      })
    },
    /**
     * 显示倒计时
     */
    loopTime (clear) {
      if (!this.sending) {
        this.time = 60

        return
      }

      setTimeout(() => {
        this.time--

        if (this.time > 0) {
          this.loopTime(clear)
        } else {
          clear && clear()
          this.sending = false
          this.time = 60
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
// .captcha-text {
//   height: 42px;
//   margin-bottom: 32px;

//   @include mobile () {
//     margin-bottom: 22px;
//   }

//   &.gkui-form-element[gktext-color="underline"] ::v-deep {
//     & [gk-form-element-tips] {
//       top: -24px;
//       @include lineFont(14, 400);
//       color: #17B04B;

//       @include mobile () {
//         font-size: 12px;
//       }
//     }
//   }
// }
.text-tips {
  margin-bottom: 32px;
}

.send-mobile {
  height: 43px;
  text-align: right;
  line-height: 43px;
  font-size: 14px;
  color: $orange;
  cursor: pointer;
  user-select: none;
}

[gk-button] {
  padding: 0;
  @include lineFont(14);
  color: $blue;
  justify-content: flex-end;
  font-family: PingFang SC, Helvetica Neue, Verdana, Microsoft Yahei, Hiragino Sans GB, Microsoft Sans Serif, WenQuanYi Micro Hei, sans-serif;

  @include mobile {
    padding: 0 2px;
    font-size: 14px;
  }

  &:hover {
    color: $blue;
  }

  &[disabled],
  &[disabled]:hover,
  &[disabled]:active {
    background: transparent;
    // color: $lightGray;
    opacity: 0.6;
  }
}
</style>
